/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TrainingCourseTypeRolesInner { 
    /**
     * 
     */
    credentials: string;
    /**
     * 
     */
    descr?: string;
    /**
     * 
     */
    access: TrainingCourseTypeRolesInner.AccessEnum;
    /**
     * 
     */
    admin?: boolean;
    /**
     * 
     */
    selectable?: boolean;
    /**
     * 
     */
    required?: boolean;
}
export namespace TrainingCourseTypeRolesInner {
    export type AccessEnum = 'full' | 'limited' | 'none';
    export const AccessEnum = {
        Full: 'full' as AccessEnum,
        Limited: 'limited' as AccessEnum,
        None: 'none' as AccessEnum
    };
}


